/**
 * Réglage de la déclaration d'incident — M8 (retour Manon, mi-parcours).
 *
 * La commune décide si un HABITANT doit joindre une photo pour déclarer un
 * incident. Pour le personnel (accueil, téléphone, tournée), la photo est
 * toujours facultative. Enregistré à la bascule, sans bouton « Enregistrer ».
 */
import { useEffect, useState } from 'react';
import { Card } from '@/components/ui';
import { api, ApiException } from '@/lib/api';

export function ReglageDeclarationCard() {
  const [valeur, setValeur] = useState<boolean | null>(null);
  const [etat, setEtat] = useState<string | null>(null);

  useEffect(() => {
    api.serviceTechnique.arretes.parametresSt.get()
      .then((p) => setValeur(p.photoObligatoireAdministre ?? true))
      .catch(() => setValeur(null)); // pas d'accès au service technique : carte masquée
  }, []);

  if (valeur === null) return null;

  async function basculer(v: boolean) {
    setValeur(v); setEtat('Enregistrement…');
    try {
      const r = await api.serviceTechnique.arretes.parametresSt.update({ photoObligatoireAdministre: v });
      setValeur(r.photoObligatoireAdministre);
      setEtat('Enregistré.');
    } catch (e) {
      setValeur(!v);
      setEtat(e instanceof ApiException ? e.payload.error : 'Enregistrement impossible');
    }
  }

  return (
    <Card variant="glass" padded className="mt-4">
      <h2 className="font-display text-base font-semibold text-ink">Déclaration d'un incident</h2>
      <label className="mt-3 flex cursor-pointer items-start gap-3">
        <input type="checkbox" className="mt-1" checked={valeur}
          onChange={(e) => void basculer(e.target.checked)} />
        <span className="text-sm text-ink">
          Exiger une photo quand un <b>habitant</b> déclare un incident
          <span className="block text-xs text-ink-muted">
            Pour le personnel de la mairie (accueil, téléphone, tournée), la photo reste
            toujours facultative.
          </span>
        </span>
      </label>
      {etat && <p className="mt-2 text-xs text-ink-subtle" role="status">{etat}</p>}
    </Card>
  );
}
